import { useEffect, useState, useContext } from "react";
import BoxTitle from "../../box/title/BoxTitle";
import BoxSubTitle from "../../box/subTitle/BoxSubTitle";
import BoxEntity from "../../box/entity/BoxEntity";
import CustomSlider from "../../customSlider/CustomSlider";

import { LoadingDot } from "../../UI/spinners/LoadingSpinners";
import { getCategoryInfos } from "../../Map/utils";
import { MeteoInfoDataContext } from "../../../hooks/context";
import { useAllContexts } from "../../../hooks/useAllContexts";
import { useTranslation } from "react-i18next";

const Meteor = ({ typeId, title, type, isDaily = false }) => {
  const [categoryData, setCategoryData] = useState(null);
  const { meteoInfoData, loading } = useContext(MeteoInfoDataContext);
  const { environment, bins, hum } = useAllContexts();
  const [environmentData, setEnvironmentData] = useState(null);
  const [environmentLoading, setEnvironmentLoading] = useState(true);

  const { environmentalData, averageEnvironmentalData, averageLoading } =
    environment;
  const { t } = useTranslation();

  const lTypeId = typeId.replace("a", "");

  useEffect(() => {
    setCategoryData(getCategoryInfos(lTypeId));
  }, []);

  useEffect(() => {
    setEnvironmentLoading(isDaily ? averageLoading : environment.loading);
  }, [environment.loading, averageLoading]);

  useEffect(() => {
    if (lTypeId === "1") {
      setEnvironmentData(
        isDaily ? averageEnvironmentalData : environmentalData,
      );
    }
  }, [lTypeId, environmentalData, averageEnvironmentalData]);

  const handleDate = (timestamp) => {
    const timestampToDate = new Date(timestamp * 1000);

    const addZero = (value) => (value < 10 ? `0${value}` : value);

    return `${addZero(timestampToDate.getDate())}/${addZero(
      timestampToDate.getMonth() + 1,
    )}/${timestampToDate.getFullYear()} ${addZero(
      timestampToDate.getUTCHours(),
    )}:${addZero(timestampToDate.getUTCMinutes())}:${addZero(
      timestampToDate.getUTCSeconds(),
    )}`;
  };

  const renderProblem = () => {
    return (
      <p
        style={{
          fontWeight: "600",
          fontSize: "14px",
          paddingTop: "10px",
          color: "#333",
        }}
      >
        Αδυναμία λήψης δεδομένων λόγω προβλήματος
      </p>
    );
  };

  const renderItems = (start, end, items) => {
    const tempItems = [];
    for (let itemIndex = start; itemIndex < end; itemIndex++) {
      tempItems.push(items[itemIndex]);
    }

    return tempItems.map((item, index) => {
      return (
        <div key={`${item.group_name}_index`}>
          <BoxEntity
            key={index}
            icon={`https://volos.smartiscity.gr/gallery/vars/Small/${item.sensorvar_icon}`}
            content={item.group_name}
            value={`${parseInt(item.group_val).toFixed(2)} ${
              item.sensorvar_unit
            }`}
            // date={item.date_insert}
          />
        </div>
      );
    });
  };

  return (
    <>
      {loading && <LoadingDot />}
      <BoxTitle
        icon={`im ${categoryData?.icon}`}
        title={title}
        link={`/map?typeId=${typeId}`}
        infoContext={t(`${type}.tooltip`)}
        element={
          <i
            id="draggable"
            className="im im-icon-Double-Tap"
            style={{ fontSize: "32px", minWidth: "32px", cursor: "pointer" }}
          />
        }
        isDailyAverage={isDaily}
        id={lTypeId}
      />
      {lTypeId === "5" &&
        (meteoInfoData?.length > 0 ? (
          <CustomSlider>
            {meteoInfoData?.map((infoItem, index) => {
              return (
                <div key={index}>
                  <BoxSubTitle>Bόλος</BoxSubTitle>
                  {/* <BoxSubTitle>{infoItem.sensor_address}</BoxSubTitle> */}
                  {infoItem.details.map((infoDetail, index) => {
                    return (
                      <BoxEntity
                        key={index}
                        icon={`https://volos.smartiscity.gr/gallery/vars/Small/${infoDetail.sensorvar_icon}`}
                        content={infoDetail.sensorvar_description}
                        value={`${parseInt(infoDetail.measurement).toFixed(
                          2,
                        )} ${infoDetail.sensorvar_unit}`}
                        date={infoDetail.date_insert}
                      />
                    );
                  })}
                </div>
              );
            })}
          </CustomSlider>
        ) : (
          renderProblem()
        ))}
      {lTypeId === "1" && !environmentData && <LoadingDot />}
      {lTypeId === "1" &&
        (environmentData ? (
          <CustomSlider>
            {environmentData?.map((infoItem, index) => {
              console.log("infoItem", infoItem);
              return (
                <div key={index}>
                  <div
                    style={{
                      display: "flex",
                      Height: "220px",
                      flexDirection: "column",
                      gap: "2px",
                      justifyContent: "center",
                      alignItems: "center",
                      whiteSpace: "pre",
                    }}
                  >
                    <BoxSubTitle>
                      {t(`areaNames.${infoItem?.ref_id}`)}
                      {/* {infoItem?.sensor_address ?? infoItem?.mysensor_name} */}
                    </BoxSubTitle>
                    <div style={{ fontSize: "12px" }}>
                      {isDaily
                        ? t("environmental.average_day")
                        : t("environmental.average_hour")}
                    </div>
                  </div>
                  <div
                    role="region"
                    style={{
                      width: "100%",
                      height: "400px",
                      overflowY: "scroll",
                      scrollbarWidth: "none",
                    }}
                    tabIndex={0}
                    aria-label={`Sensor readings for ${infoItem?.mysensor_name}`}
                  >
                    {infoItem?.details.map((infoDetail, index) => {
                      return (
                        <BoxEntity
                          key={`map_${index}`}
                          icon={`https://volos.smartiscity.gr/gallery/vars/Small/${infoDetail.sensorvar_icon}`}
                          content={t(
                            `dataNames.${infoDetail.sensorvar_icon.slice(
                              0,
                              -4,
                            )}`,
                          )}
                          // content={infoDetail.sensorvar_description}
                          value={
                            <>
                              <p>
                                {parseFloat(infoDetail.measurement).toFixed(2)}
                              </p>
                              <p>{infoDetail.sensorvar_unit}</p>
                            </>
                          }
                          // value={`${parseFloat(infoDetail.measurement).toFixed(
                          //   2
                          // )} ${infoDetail.sensorvar_unit}`}
                          date={handleDate(infoDetail.timestamp)}
                        />
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </CustomSlider>
        ) : (
          environmentData?.length === 0 && renderProblem()
        ))}
      {lTypeId === "12" &&
        (hum ? (
          <CustomSlider>
            {hum?.humData && renderItems(0, 8, hum?.humData?.group)}
            {
              // hum?.humData.group.map((infoItem, index) => {
              //   return (
              //     <BoxEntity
              //       key={index}
              //       icon={`im im-icon-On-Off-3`}
              //       content={infoItem.group_name}
              //       value={`${parseInt(infoItem.group_val).toFixed(2)} ${
              //         infoItem.sensorvar_unit
              //       }`}
              //     />
              // <div key={index}>
              //   {/* <BoxSubTitle>{infoItem.group_name}</BoxSubTitle> */}
              //   {/* {infoItem.details.map((infoDetail, index) => {
              //     return (
              //     );
              //   })} */}
              // </div>
              //   );
              // })
            }
          </CustomSlider>
        ) : (
          renderProblem()
        ))}
    </>
  );
};

export default Meteor;
